import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Chat.css";
import { env } from "../../environment";
import dropDownLogo from "../../assets/images/downArrow.svg";
import { useNavigate } from "react-router-dom";
import logoutConfirm from "../../assets/images/logout.png";
import appsLogo from "../../assets/images/UPL_Genie_logo 1.svg";
import genAI from "../../assets/images/LogoWelcome.svg";
import uplLogo from "../../assets/images/UPL_Genie_logo 1.svg";
import { fetchModelDetails, postFeedback } from "../../store/apiActions";
import { useDispatch, useSelector } from "react-redux";
import outputArrow from "../../assets/images/outputArrow.png";
import like from "../../assets/images/like.svg";
import dislike from "../../assets/images/dislike.svg";
import likeSelected from "../../assets/images/likeSelected.svg";
import dislikeSelected from "../../assets/images/dislikeSelected.svg";
import closeIcon from "../../assets/images/closeIcon.png";
import { marked } from "marked";
import fileDoc from "../../assets/images/mainCard1.svg";
import help from "../../assets/images/mainCard2.svg";
import compareDoc from "../../assets/images/mainCard3.svg";
import Sidebar from "../../components/Sidebar/Sidebar";
import Tooltip from "../../components/Title/Title";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import setting from "../../assets/images/settings.svg";
import profileIcon from "../../assets/images/profile.svg";
import sidebarIcon1 from "../../assets/images/Black.svg";
import sidebarIcon2 from "../../assets/images/Black-1.svg";
import sidebarIcon4 from "../../assets/images/Black-2.svg";
import sidebarIcon1Active from "../../assets/images/White.svg";
import sidebarIcon2Active from "../../assets/images/White-1.svg";
import sidebarIcon4Active from "../../assets/images/White-2.svg";
import botIcon from "../../assets/images/Menu Icon Background.svg";

function Chat() {
  const roles = [
    {
      id: 1,
      name: "Wordsmith",
      text: "Hi, I am Wordsmith, your intelligent writing companion designed to elevate your content creation. Whether you are drafting reports, presentations, or composing professional emails, I am here to help you communicate with clarity, precision, and style.",
      icon: sidebarIcon1,
      title: "Professional writing assistant",
      activeIcon: sidebarIcon1Active,
    },
    {
      id: 2,
      name: "Agronomica",
      text: "Hi, I am Agronomica, your expert agricultural companion dedicated to answering questions about crop science, soil management, sustainable farming, and agricultural technologies. From soil health to crop optimisation, I am here to provide insights and support for you.",
      icon: sidebarIcon2,
      title: "Sustainable farming guide",
      activeIcon: sidebarIcon2Active,
    },
    {
      id: 3,
      name: "Regulatrix",
      text: "Hi, I am Regulatrix, your comprehensive regulatory companion for the agrochemical industry, designed to navigate the complex landscape of agricultural regulations and compliance standards. I provide expert guidance on regulatory requirements, safety protocols, environmental regulations, and compliance strategies to support your agricultural business legal and ethical operations.",
      icon: sidebarIcon4,
      title: "Agrochemical compliance advisor",
      activeIcon: sidebarIcon4Active,
    },
  ];
  const [activeTab, setActiveTab] = useState();
  const [message, setMessage] = useState("");
  const [attachedFile, setAttachedFile] = useState(null);
  const [messages, setMessages] = useState([]);
  const [cardClicked, setCardClicked] = useState(false);
  const chatEndRef = useRef(null);
  const navigate = useNavigate();
  const [selectedModel, setSelectedModel] = useState("GPT-4o");
  const [model, setModel] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [converstation, setConverstation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getUsername = () => {
    const storedData = localStorage.getItem("LoggedInDetails");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.username;
    }
    return null;
  };
  const getFullname = () => {
    const storedData = localStorage.getItem("LoggedInDetails");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.full_name;
    }
    return null;
  };
  const username = getUsername();
  const fullname = getFullname();

  const clearChatData = () => {
    setConverstation([]);
    setMessages([]);
    const newSessionId = crypto?.randomUUID();
    setSessionId(newSessionId);
    localStorage.setItem("sessionId", newSessionId);
    setShowChatModal(false);
  };
  const [selectedRoleDetails, setSelectedRoleDetailes] = useState([]);
  const addMessagesFunction = (role_name, text) => {
    setTimeout(() => {
      const botMessage = { sender: "bot", text: text, message_id: null };
      setSelectedRoleDetailes(botMessage);
    }, 50);
  };

  useEffect(() => {
    clearChatData();
  }, [activeTab]);

  const handleSendMessage = async () => {
    if (message.trim() || attachedFile) {
      const userMessage = { sender: "user", text: message };
      setMessages((prevMessages) => [userMessage, ...prevMessages]);
      const placeholderBotMessage = {
        sender: "bot",
        text: "Loading...",
      };
      setMessages((prevMessages) => [
        userMessage,
        placeholderBotMessage,
        ...prevMessages,
      ]);
      setMessage("");
      setAttachedFile(null);
      let token = localStorage.getItem("token");
      setIsLoading(true);
      try {
        const response = await fetch(`${env.baseURL}/chat/completions`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ugdn_id: "",
            user_id: username,
            chat_id: `UID${sessionId.substring(0, 3)}`,
            message_id: "",
            session_id: sessionId,
            tool_ids: [],
            files: [],
            features: {
              additionalProp1: "",
              additionalProp2: "",
              additionalProp3: "",
            },
            variables: {
              additionalProp1: "",
              additionalProp2: "",
              additionalProp3: "",
            },
            model: selectedModel,
            messages: converstation,
            query: message,
            role_name: roles[activeTab - 1]?.name || "",
            role_flag: roles[activeTab - 1]?.name?.length ? "True" : "False",
            params: {},
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch chatbot response");
        }
        const data = await response.json();
        setIsLoading(false);
        setConverstation(data.converstation);
        const botMessage = {
          sender: "bot",
          text: data?.response?.response_text,
          message_id: data.message_id,
        };

        setMessages((prevMessages) => {
          const newMessages = [...prevMessages];
          newMessages[1] = botMessage; // Replace the placeholder bot message
          return newMessages;
        });
      } catch (error) {
        setIsLoading(false);
        const errorMessage = {
          sender: "bot",
          text: "Sorry, I'm having trouble understanding that.",
        };
        setMessages((prevMessages) => {
          const newMessages = [...prevMessages];
          newMessages[1] = errorMessage; // Replace the placeholder with error message
          return newMessages;
        });
      }
    }
  };

  const { subscribe } = useEventEmitter();
  // Function to handle thread selection
  useEffect(() => {
    // Subscribe to the 'resetChild' event
    const unsubscribe = subscribe("thread", (data) => {
      localStorage.setItem("selectedThreadData", JSON.stringify(data));
      //Clear the messages on change of thread
      setMessages([]);
    });
    // Cleanup the subscription on unmount
    return () => unsubscribe();
  }, [subscribe]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        event.preventDefault();
        setMessage((prev) => prev + "\n");
      } else {
        event.preventDefault();
        handleSendMessage();
      }
    }
  };

  useEffect(() => {
    let data = localStorage.getItem("isLogin");
    if (data) {
      toast.success("You are successfully logged in");
      localStorage.removeItem("isLogin");
    }
  }, []);

  // Trigger handleSendMessage when cardClicked is true
  useEffect(() => {
    if (cardClicked) {
      handleSendMessage();
      setCardClicked(false);
    }
  }, [cardClicked]);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleModelChange = (eventOrName) => {
    let modelName;

    if (typeof eventOrName === "string") {
      // If it's called from the div click
      modelName = eventOrName;
    } else if (eventOrName?.target?.value) {
      // If it's called from the radio button change event
      modelName = eventOrName.target.value;
    }

    if (modelName) {
      setSelectedModel(modelName);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    toast.success("Logout successful!");
    localStorage.clear();
    setShowModal(false);
    navigate("/sign-in");
  };

  const handleContinue = () => {
    setShowChatModal(false);
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchModelDetails(`${env.baseURL}/models/base`));
  }, [dispatch]);
  const modelResponse = useSelector(
    (state) => state?.api?.modelDetails?.data || []
  );

  useEffect(() => {
    setModel(modelResponse?.data);
  }, [modelResponse]);

  const [feedbackButtonsDisabled, setFeedbackButtonsDisabled] = useState(() => {
    const savedDisabled = localStorage.getItem("feedbackButtonsDisabled");
    return savedDisabled && savedDisabled !== "undefined"
      ? JSON.parse(savedDisabled)
      : {};
  });
  const [selectedFeedback, setSelectedFeedback] = useState({});
  const [feedbackInput, setFeedbackInput] = useState("");
  const [feedbackData, setFeedbackData] = useState({});
  const [currentFeedbackIndex, setCurrentFeedbackIndex] = useState(null);
  const [showFeedbackInput, setShowFeedbackInput] = useState(false);
  const feedbackInputRef = useRef(null);
  const feedbackContainerRef = useRef(null);
  const [feedbackDetails, setFeedbackDetails] = useState("");

  const handleFeedback = (index, type, data) => {
    setFeedbackDetails(data);
    if (selectedFeedback[index] !== type) {
      setFeedbackInput((prevFeedback) => {
        const updatedFeedback = { ...prevFeedback };
        if (updatedFeedback[index]) {
          delete updatedFeedback[index];
        }
        return updatedFeedback;
      });
      setFeedbackInput("");
    }

    setFeedbackData((prevFeedback) => ({
      ...prevFeedback,
      [index]: { type, comment: "" },
    }));

    setSelectedFeedback((prev) => ({
      // ...prev,
      [index]: type,
      // Store feedback per message index
    }));
    setCurrentFeedbackIndex(index);
    setShowFeedbackInput(true);
    setTimeout(() => {
      // handleDirectFeedback(type)
      if (
        feedbackInputRef.current &&
        feedbackContainerRef.current.offsetParent !== null
      ) {
        feedbackInputRef.current.focus();
        feedbackContainerRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 0);
  };

  const handleFeedbackModalClose = (index) => {
    setShowFeedbackInput(false);
    setCurrentFeedbackIndex(null);
    setSelectedFeedback((prevFeedback) => {
      const updatedFeedback = { ...prevFeedback };
      delete updatedFeedback[index]; // Remove the specific index
      return updatedFeedback;
    });
    setFeedbackInput({});
  };

  const handleFeedbackCommentChange = (event) => {
    const updatedComment = event.target.value;
    setFeedbackInput((prevFeedback) => ({
      ...prevFeedback,
      [currentFeedbackIndex]: {
        ...prevFeedback[currentFeedbackIndex],
        comment: updatedComment,
      },
    }));
  };

  const handleKeyPressFeedback = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent any Enter key behavior
      handleFeedbackSubmit();
      if (event.shiftKey) {
        setFeedbackInput((prevFeedback) => ({
          ...prevFeedback,
          [currentFeedbackIndex]: {
            ...prevFeedback[currentFeedbackIndex],
            comment: (prevFeedback[currentFeedbackIndex]?.comment || "") + "\n",
          },
        }));
      }
    }
  };

  const handleFeedbackSubmit = async () => {
    if (submittingFeedback) {
      return;
    }
    setSubmittingFeedback(true);

    try {
      const requestBody = {
        session_id: sessionId,
        message_id: feedbackDetails?.message_id,
        feedback: feedbackData[currentFeedbackIndex]?.type || "",
        feedback_comment: feedbackInput[currentFeedbackIndex]?.comment || "",
        user_id: username,
      };
      await dispatch(
        postFeedback(`${env.baseURL}/update-feedback-chat`, requestBody)
      );

      // Disable the button for the current index
      setFeedbackButtonsDisabled((prev) => ({
        ...prev,
        [currentFeedbackIndex]: true,
      }));

      // Show success message
      toast.success("Feedback submitted successfully");

      // Clear only the submitted feedback input
      setFeedbackInput((prev) => ({
        ...prev,
        [currentFeedbackIndex]: { comment: "" },
      }));

      // Clear feedback data for the current index
      setFeedbackData((prevFeedback) => ({
        ...prevFeedback,
        [currentFeedbackIndex]: { type: "", comment: "" },
      }));

      setShowFeedbackInput(false);
      setCurrentFeedbackIndex(null);
    } catch (error) {
      toast.error("Failed to submit feedback");
    } finally {
      setSubmittingFeedback(false);
    }
  };

  const handleDirectFeedback = async (type) => {
    try {
      const requestBody = {
        session_id: sessionId,
        message_id: feedbackDetails?.message_id,
        feedback: "",
        feedback_comment: type || "",
        user_id: username,
      };
      await dispatch(
        postFeedback(`${env.baseURL}/update-feedback-chat`, requestBody)
      );
      toast.success("Feedback submitted successfully");
    } catch (error) {
      toast.error("Failed to submit feedback");
    }
  };
  const [hoveredId, setHoveredId] = useState(null);



  const [submittingFeedback, setSubmittingFeedback] = useState(false);
  const [sessionId, setSessionId] = useState("");
  useEffect(() => {
    const newSessionId = crypto.randomUUID();
    setSessionId(newSessionId);
    localStorage.setItem("sessionId", newSessionId);
  }, []);

  return (
    <>
      <ToastContainer closeButton={false} position="top-right" />
      <div className="chat-container">
        <div
          style={{
            height: "100%",
            backgroundColor: "#F9F9F9",
            overflowY: "hiden",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            gridTemplateRows: "11% 89%",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="chatbot-logo">
              <div
                style={{
                  paddingLeft: "3%",
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <img height={"70%"} width={"70%"} src={uplLogo} alt="" />
                {/* <img height={"60%"} width={"60%"} src={appsLogo} alt="" /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div className="model-selector" ref={dropdownRef}>
                  <div className="select-dropdown" onClick={handleToggle}>
                    <span className="selector-text">
                      {selectedModel || "No Model Available"}
                    </span>
                    <img
                      src={dropDownLogo}
                      alt="Dropdown Icon"
                      className={`selector-arrow ${isOpen ? "rotate" : ""}`}
                    />
                    {/* Model Options Dropdown */}
                    {isOpen && (
                      <div className="selector-menu">
                        {model.map((item) => (
                          <div
                            key={item.id}
                            className={`selector-item ${
                              selectedModel === item.name ? "active" : ""
                            }`}
                            onClick={() => handleModelChange(item.name)}
                          >
                            <label
                              htmlFor={`radio-${item.name}`}
                              className="radio-label"
                            >
                              <input
                                type="radio"
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  cursor: "pointer",
                                }}
                                id={`radio-${item.name}`}
                                name="label"
                                value={item.name}
                                checked={selectedModel === item.name}
                                onChange={handleModelChange}
                                className="radio-selector"
                              />
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className=""></div>
                </div>
                <div className="profile-container-header">
                  <div>
                    <img src={profileIcon} alt="" />
                  </div>
                  <div
                    style={{
                      marginRight: "8px",
                      padding: "5px 12px 5px 5px",
                      fontSize: "16px",
                      fontWeight: "normal",
                      border: "none",
                      color: "#000000E5",
                      background: "none",
                    }}
                  >
                    {fullname}
                  </div>
                  <div className="setting-container">
                    <Tooltip id={0}>
                      <img src={setting} alt="settings" />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              height: "100%",
              backgroundColor: "#FFF",
            }}
          >
            <div className="sidebar-chat-container">
              <Sidebar />
              <div
                className="chat-header-container"
                style={{
                  display: "grid",
                  gridTemplateRows:
                    roles[activeTab - 1]?.name?.length > 0
                      ? "7% 75% 18%"
                      : "78% 22%",
                }}
              >
                {roles[activeTab - 1]?.name?.length > 0 && (
                  <div className="chat-end-section">
                    <span>
                      You’re chatting with: {roles[activeTab - 1]?.name || ""}
                    </span>
                    <button
                      onClick={() => setShowChatModal(true)}
                      className="chat-end-button"
                    >
                      End Chat
                    </button>
                  </div>
                )}
                <div className="chat-box">
                  {roles[activeTab - 1]?.name?.length > 0 && (
                    <div className="message-container bot-message">
                      <div>
                        <img src={botIcon} alt="" />
                      </div>
                      <div>
                        <div className="message-content">
                          <div style={{ margin: "0px" }}>
                            <span>{selectedRoleDetails?.text}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {messages.length === 0 &&
                  !(roles[activeTab - 1]?.name?.length > 0) ? (
                    <div className="chat-container-dashboard">
                      <div className="dashboard-profile-container"></div>
                      <div>
                        <h2 className="how-title">How can I help you?</h2>
                        <div className="card-container">
                          <Tooltip>
                            <div className="card-item">
                              <span>
                                <img
                                  style={{ width: "25px", height: "25px" }}
                                  src={fileDoc}
                                  alt=""
                                />
                              </span>
                              <span>Summarise Documents</span>
                              <span className="card-item-sub-text">
                                Get your documents summarised instantly
                              </span>
                            </div>
                          </Tooltip>
                          <Tooltip>
                            <div className="card-item">
                              <span>
                                <img
                                  style={{ width: "25px", height: "25px" }}
                                  src={help}
                                  alt=""
                                />
                              </span>
                              <span>Excel to Insights</span>
                              <span className="card-item-sub-text">
                                Upload excel docs and get insights
                              </span>
                            </div>
                          </Tooltip>
                          <Tooltip>
                            <div className="card-item">
                              <span>
                                <img
                                  style={{ width: "25px", height: "25px" }}
                                  src={compareDoc}
                                  alt=""
                                />
                              </span>
                              <span>Chat with Docs</span>
                              <span className="card-item-sub-text">
                                Ask questions with the documents
                              </span>
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {messages
                        .slice()
                        .reverse()
                        .reduce(
                          (
                            groupedMessages,
                            currentMessage,
                            index,
                            reversedArray
                          ) => {
                            if (
                              currentMessage.sender === "bot" &&
                              reversedArray[index + 1]?.sender === "user"
                            ) {
                              groupedMessages.push({
                                userMessage: reversedArray[index + 1],
                                botMessage: currentMessage,
                              });
                            }
                            return groupedMessages;
                          },
                          []
                        )
                        .map((pair, index) => (
                          <span key={index}>
                            {/* User Message */}
                            {pair.userMessage && (
                              <div className="message-container user-message">
                                <div className="profile-icon-alignment">
                                  <img src={profileIcon} alt="" />
                                </div>
                                <div className="profile-icon-alignment">
                                  <div className="message-content">
                                    {pair.userMessage.text}
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* Bot Message */}
                            {pair.botMessage && (
                              <div className="message-container bot-message">
                                <div>
                                  <img src={botIcon} alt="" />
                                </div>
                                <div>
                                  <div className="message-content">
                                    <div style={{ margin: "0px" }}>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: marked(pair.botMessage.text),
                                        }}
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {pair.botMessage.text !== "Loading..." ? (
                              <div className="feedback-buttons">
                                <button
                                  className={`like-button ${
                                    feedbackButtonsDisabled[index]
                                      ? "disabled"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    handleFeedback(
                                      index,
                                      "like",
                                      pair?.botMessage
                                    )
                                  }
                                  disabled={feedbackButtonsDisabled[index]} // Now disabled only after submit
                                >
                                  <img
                                    src={
                                      selectedFeedback[index] === "like"
                                        ? likeSelected
                                        : like
                                    }
                                    className="like-dislike-img"
                                    alt="like-image"
                                  />
                                </button>
                                <button
                                  className={`dislike-button ${
                                    feedbackButtonsDisabled[index]
                                      ? "disabled"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    handleFeedback(
                                      index,
                                      "dislike",
                                      pair?.botMessage
                                    )
                                  }
                                  disabled={feedbackButtonsDisabled[index]}
                                >
                                  <img
                                    src={
                                      selectedFeedback[index] === "dislike"
                                        ? dislikeSelected
                                        : dislike
                                    }
                                    className="like-dislike-img"
                                    alt="dislike-image"
                                  />
                                </button>
                              </div>
                            ) : (
                              <div className="feedback-buttons"></div>
                            )}
                            {showFeedbackInput &&
                              currentFeedbackIndex === index && (
                                <div
                                  ref={feedbackContainerRef}
                                  className="additional-feedback"
                                >
                                  <button
                                    className="close-arrow"
                                    onClick={() => {
                                      handleFeedbackModalClose(index);
                                    }}
                                  >
                                    <img src={closeIcon} alt="arrow-icon" />
                                  </button>
                                  <div className="feedback-input-area">
                                    <textarea
                                      ref={feedbackInputRef}
                                      className="feedback-input"
                                      value={
                                        feedbackInput[index]?.comment || ""
                                      }
                                      onChange={handleFeedbackCommentChange}
                                      placeholder={"Your feedback"}
                                      onKeyDown={handleKeyPressFeedback}
                                      style={{ resize: "none" }}
                                    />
                                  </div>
                                </div>
                              )}
                          </span>
                        ))}
                    </>
                  )}
                  <div ref={chatEndRef}></div>
                </div>
                <div style={{ width: "71%", height: "100%" }}>
                  <div className="card-role-container">
                    {!activeTab &&
                      roles.map((role) => (
                        <Tooltip id={"1"} text={role.title} key={role.id}>
                           <div
      key={role.id}
      className={`card-items-role ${activeTab === role.id ? "active" : ""}`}
      onClick={() => {
        if (activeTab !== role.id) {
          addMessagesFunction(role.name, role.text);
        }
        setActiveTab(activeTab === role.id ? null : role.id);
      }}
      onMouseEnter={() => setHoveredId(role.id)}
      onMouseLeave={() => setHoveredId(null)}
    >
      <img
        src={hoveredId === role.id ? role.activeIcon : role.icon} // Change only hovered image
        alt={role.name}
      />
      {role.name}
    </div>
                        </Tooltip>
                      ))}
                  </div>
                  <div className="input-container">
                    <textarea
                      className={`input-box ${isLoading ? "disabled" : ""}`}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={handleKeyPress}
                      placeholder="Ask me anything..."
                      rows="3"
                      autoComplete="off"
                      style={{ resize: "none" }}
                      disabled={isLoading}
                    ></textarea>
                    <button
                      className={`output-arrow ${isLoading ? "disabled" : ""}`}
                      onClick={handleSendMessage}
                    >
                      <img src={outputArrow} alt="arrow-icon" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LogoutModal
          show={showModal}
          handleLogout={handleLogout}
          handleClose={handleCloseModal}
        />
        <EndChatModel
          role_name={roles[activeTab - 1]?.name || ""}
          show={showChatModal}
          handleContinue={handleContinue}
          handleEndChat={() => {
            clearChatData();
            setActiveTab(null);
          }}
        />
      </div>
    </>
  );
}

export default Chat;

const LogoutModal = ({ show, handleLogout, handleClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="logout-icon">
          <img src={logoutConfirm} alt="Logout Icon" />
        </div>
        <div className="logout-text">Are you sure you want to LogOut?</div>
        <div className="modal-buttons">
          <button onClick={handleLogout} className="yes-btn">
            Yes
          </button>
          <button onClick={handleClose} className="no-btn">
            No
          </button>
        </div>
      </div>
    </div>
  );
};

const EndChatModel = ({ show, handleEndChat, handleContinue, role_name }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="chat-modal-content">
        <div className="end-chat-title">End chat</div>
        <div className="chat-text">
          You are about to end your conversation with {role_name}!
        </div>
        <div className="chat-modal-buttons">
          <button onClick={handleEndChat} className="end-btn">
            End
          </button>
          <button onClick={handleContinue} className="continue-btn">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};
